export const ENTITY_DEALS_TABS = {
  INVESTOR: 'investor',
  PROVIDER: 'provider',
  COMPANY_PROFILES: 'company-profiles',
  PIPELINE: 'pipeline',
} as const;

export type EntityDealsTabKey = (typeof ENTITY_DEALS_TABS)[keyof typeof ENTITY_DEALS_TABS];

export const entityDealsTabs = [
  { key: ENTITY_DEALS_TABS.INVESTOR, label: 'Investor View' },
  { key: ENTITY_DEALS_TABS.PROVIDER, label: 'Provider View' },
  { key: ENTITY_DEALS_TABS.COMPANY_PROFILES, label: 'Company Profiles' },
  { key: ENTITY_DEALS_TABS.PIPELINE, label: 'My Pipeline' },
];
